import type { VoidFunctionComponent } from 'react';

import styles from './DetailsPanel.module.less';

export type DetailsPanelTextProps = {
  text: string;
};

const DetailsPanelText: VoidFunctionComponent<DetailsPanelTextProps> = ({ text }) => (
  <div className={styles.row}>
    <span className={styles.text}>
      {text}
    </span>
  </div>
);

export default DetailsPanelText;
